import React,{ useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { ButtonSubmit } from '../../../StyledComponents/Common';
import { ContentRow, ContentTitle, ContentValue, DetailContainer } from '../../../StyledComponents/CreateKeyAccountManager'
import { IconImg } from '../../../StyledComponents/Header';
import { Modal, Input } from 'antd';
import styled from 'styled-components';
import { getFormattedDateTime } from '../../../functions/Utils';
import { handle_payment_request } from '../../../store/Admin/PaymentRequest/PaymentRequestSlice';
import { useDispatch } from 'react-redux';
// import RadioGroups from '../Common/RadioGroups';
import RadioGroupsPayment from '../Common/RadioGroupPayment';
import { updatenotificationdata } from '../../../store/Admin/Common/CommonSlice';

const { TextArea } = Input;


function PaymentView(props) {
    const dispatch = useDispatch()
    const location = useLocation();
    const [isLoad, setIsLoad] = useState(true);
    const [showError, setShowError] = useState(false);
    const [hideButton, setHideButton] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
    const [acceptedLoading, setAcceptedLoading] = useState(false);
    const [rejectedLoading, setRejectedLoading] = useState(false);
    const [rejectionRason, setRejectionReason] = useState({
        reason_for_rejection: "UTR/Cheque number mismatch",
        other_reason: ""
    });
    const [showMsg, setShowMsg] = useState("Booking Confirmed");
console.log("props",props)
    let radio_datas = [
        {
            id: "UTR/Cheque number mismatch",
            name: "UTR/Cheque number mismatch"
        },
        {
            id: "Payment not Received",
            name: "Payment not Received"
        },
        {
            id: "Other",
            name: "Other"
        }
    ]

    

    useEffect(()=> {
        if(isModalOpen){
            const timer = setTimeout(() => {
                setIsModalOpen(false);
              }, 1000);
        
              return () => clearTimeout(timer);
        }
    },[isModalOpen])

    useEffect(()=> {
        if(location.pathname === '/payment-request'){
        if(isLoad === false){
            props.setPageType("table")
        }else {
            setIsLoad(false)
        }
        }
    },[location])

    const handleAccept = ()=> {
        setAcceptedLoading(true)
        let data = {
            payment_status: "Payment Confirmed",
            id: props.instance._id
        }
        dispatch(handle_payment_request(data))
        .then(res=>{
            // console.log('login res => ',res);
            if(res?.payload?.data?.statusCode === 200 ){
                setShowMsg("Payment Confirmed")
                // setIsModalOpen(true);
                let data = {
                    message : "Payment Confirmed",
                    statusCode: 200,
                    success: "success"
                }
                dispatch(updatenotificationdata(data))
                props.setPageType("table")
            }
            setAcceptedLoading(false)
        })
        .catch(err=>{
            console.error(err);
            setAcceptedLoading(false)
        })
        
    }
    const handleReject = ()=> {
        setIsRejectModalOpen(true)
        setShowMsg("Booking Rejected")
    }
    const handleRejectSend =()=> {
        if(rejectionRason.reason_for_rejection === 'Other' && rejectionRason.other_reason === ""){
            setShowError(true)
        }else {
            setRejectedLoading(true)
            let data = {
                payment_status: "Payment Rejected",
                id: props.instance._id,
                reason_for_rejection: rejectionRason.reason_for_rejection,
                other_reason: rejectionRason.other_reason
            }
            dispatch(handle_payment_request(data))
            .then(res=>{
                // console.log('login res => ',res);
                if(res?.payload?.data?.statusCode === 200 ){
                    setHideButton(true)
                    setIsRejectModalOpen(false)
                    // setIsModalOpen(true);
                    let data = {
                        message : "Booking Rejected",
                        statusCode: 200,
                        success: "success"
                    }
                    dispatch(updatenotificationdata(data))
                    props.setPageType("table")
                }
                setRejectedLoading(false)
            })
            .catch(err=>{
                console.error(err);
                setRejectedLoading(false)
            })
        }
    }

    const handleRadioClick = (value,name) => {
        setRejectionReason((prevState)=> {
            return {
                ...prevState,
                reason_for_rejection: value
            }
        })
    }
    const handleChange = (e)=> {
        const {name, value} = e.target
        setRejectionReason((prevState)=> {
            return {
                ...prevState,
                other_reason: value
            }
        })
        setShowError(false)
    }
  return (
    <>
    <DetailContainer className='user-management'>
        <ContentRow className='mb-5'>
            <ContentTitle>
                CUSTOMER NAME
            </ContentTitle>
            <ContentValue>
                {props.instance?.customer_details?.full_name}
            </ContentValue>
        </ContentRow>
        <ContentRow className='mb-5'>
            <ContentTitle>
                DATE OF PAYMENT1
            </ContentTitle>
            <ContentValue>
            {getFormattedDateTime(props.instance.createdAt)}
            </ContentValue>
        </ContentRow>
        <ContentRow className='mb-5'>
            <ContentTitle>
                AMOUNT
            </ContentTitle>
            <ContentValue>
            ₹ {Number(props.instance.offline_amount).toFixed(2)}
            </ContentValue>
        </ContentRow>
        <ContentRow className='mb-5'>
            <ContentTitle>
                MODE OF PAYMENT
            </ContentTitle>
            <ContentValue>
            {props.instance.mode_of_payment}
            </ContentValue>
        </ContentRow>
        <ContentRow className='mb-5'>
            <ContentTitle>
                UTR NUMBER
            </ContentTitle>
            <ContentValue>
            {props.instance.UTR_number}
            </ContentValue>
        </ContentRow>
        <ContentRow className='mb-5'>
            <ContentTitle>
                Status
            </ContentTitle>
            <ContentValue className='status' status={props.instance.payment_status}>
                {props.instance.payment_status === 'Payment Rejected'? 'Booking rejected' : props.instance.payment_status }
            </ContentValue>
        </ContentRow>
        {props.instance.payment_status === 'Payment Rejected'?
            <ContentRow className='mb-5'>
                <ContentTitle>
                    Reason for Rejection
                </ContentTitle>
                {props.instance.reason_for_rejection === 'Other' ?
                <ContentValue>
                    {props.instance.other_reason}
                </ContentValue>
                : 
                <ContentValue>
                    {props.instance.reason_for_rejection}
                </ContentValue>
                }
            </ContentRow>
        : null}
       


        {props.instance.payment_status === "Waiting for Confirmation" && hideButton === false?
            <ContentRow className='gap-5'>
                <ButtonSubmit onClick={()=> handleAccept()}
                    size='large' loading={acceptedLoading} icon={<IconImg src={require('../../../assets/admin/images/tick-square.png')} />}>Accept
                </ButtonSubmit>
                <ButtonSubmit onClick={()=> handleReject()}
                    size='large' icon={<IconImg src={require('../../../assets/admin/images/reject-square.png')} />}>Reject
                </ButtonSubmit>
            </ContentRow>
        : null}
        
    </DetailContainer>
    <SuccessModal open={isModalOpen} 
        closable={false}
        footer={null}
        header={null}>
        <ModalContainer>
            <ModalTitle>Success</ModalTitle>
            <IconImg width={50} height={50} src={require('../../../assets/admin/images/tick-squareblack.png')} />
            <ModalTitle>{showMsg? showMsg : "Booking Confirmed"}</ModalTitle>
        </ModalContainer>
      </SuccessModal>

      <RejectModal open={isRejectModalOpen} 
        closable={true}
        onCancel={()=> setIsRejectModalOpen(false)}
        footer={null}
        header={null}>
        <ModalContainer>
            <ModalTitle>Reject Reason</ModalTitle>
            <RadioGroupsPayment datas={radio_datas} value={rejectionRason.reason_for_rejection} handleClick={handleRadioClick} />
            {rejectionRason.reason_for_rejection === 'Other'?
                <>
                    {/* <ModalTitle>Send Message</ModalTitle> */}
                    <MessageContainer>
                        <ModalTitle className='label'>Type Message</ModalTitle>
                        <TextArea onChange={(e)=> handleChange(e)} value={rejectionRason.other_reason} rows={6} placeholder="Please input the reason for rejecting the payment" />
                        {showError?
                            <ErrorMsg>Message is Required</ErrorMsg>
                        : null}
                    </MessageContainer>
                </>
            : null}
            <MessageContainer className='align-end'>
                <ButtonSubmit onClick={()=> handleRejectSend()}
                    size='large' loading={rejectedLoading} icon={<IconImg src={require('../../../assets/admin/images/add_invite.png')} />}>Send
                </ButtonSubmit>
            </MessageContainer>
        </ModalContainer>
      </RejectModal>
    </>
  )
}

export default PaymentView

const ErrorMsg = styled.span`
    color: red;
    font-size: 11px;
`

const SuccessModal = styled(Modal)`
    & .ant-modal-content {
        width: 75% !important;
        background: #aa8639 !important;
        /* box-shadow: 0px 20px 27px rgba(0, 0, 0, 0.05) !important; */
        border-radius: 16px !important;
        padding: 50px 0px;
    }
`

const RejectModal = styled(Modal)`
    & .ant-modal-content {
        padding: 30px 20px;
    }
`
const ModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 15px;
`
const ModalTitle = styled.span`
    font-weight: 700;
    font-size: 15px;
    line-height: 20px;
    color: #242424;
    &.label {
        color: #F23F44;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
    }
`
const MessageContainer = styled.div`
    width: 100%;
    &.align-end {
        text-align: right;
    }
`